export default __webpack_public_path__ + "static/media/sc27.b61441c5.mp4";